import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import * as myGlobals from '../global';
import { IContrasena } from './contrasena';

@Injectable({
  providedIn: 'root'
})
export class ContrasenaService {
  emailData = {
    email: ''
  };

  changeEmailData: IContrasena = {
    changePassId: '',
    newPass: '',
    newPassC: ''
  };

  private _iniciarCambioContrasenaURL = myGlobals.baseApi + '/webadmin/v1/user/start-password-change';
  private _cambiarContrasenaURL = myGlobals.baseApi + '/webadmin/v1/user/password-change';

  constructor(private http: HttpClient) {}

  startPasswordChange(emailObj) {
    return this.http.post<any>(this._iniciarCambioContrasenaURL, emailObj);
  }

  changePassword(emailObj) {
    return this.http.post<any>(this._cambiarContrasenaURL, emailObj);
  }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
